<template>
	<div class="linkage">
		<div>
			<el-select v-model="selectData.province" value-key="label" filterable size="small" @change="selectProvinceFun($event)" placeholder="请选择省份" :disabled="disabled">
				<el-option :value="item" :label="item.label" v-for="(item, index) in provinceList" :key="index"></el-option>
			</el-select>
		</div>
		<div>
			<el-select v-model="selectData.city" value-key="label" filterable size="small" @change="selectCityFun($event)" placeholder="请选择城市" :disabled="disabled">
				<el-option :value="item" :label="item.label" v-for="(item, index) in cityList" :key="index"></el-option>
			</el-select>
		</div>
		<!-- <div>
			<el-select v-model="selectData.area" value-key="label" filterable size="small" @change="selectAreaFun($event)" placeholder="请选择区县">
				<el-option :value="item" :label="item.label" v-for="(item, index) in areaList" :key="index"></el-option>
			</el-select>
		</div> -->
	</div>
</template>
<script>
	import cityData from '@/assets/json/cityData.json';
	export default {
		name: 'ChinaAreaData',
		props: {
			areaData: {
				type: Object,
				default: () => ({ province: '', city: '' }) // 设置默认值
			},
    		disabled: Boolean,
			isAddObligee: {
				type: Boolean,
				default: false // 默认值
			},
		},
		data() {
			return {
				// 整个省市县数据
				provinceList: cityData,
				// 被选中的市数据
				cityList: [],
				// 被选中的县数据
				areaList: [],
				selectData: {
					province: {},
					city: {},
					// area: {},
				}
			}
		},
		watch: {
			areaData: {
				handler(newVal) {
				// 更新组件的内部状态
				this.selectData.province = newVal.province;
				this.selectData.city = newVal.city;
				this.cityList = newVal.province ? this.provinceList.find(p => p.label === newVal.province)?.children || [] : [];
				},
				immediate: true, // 立即执行一次
				deep: true // 深度监听
			}
		},
		mounted() {},
		created() {
			// if(this.areaData){
			// 	this.selectData.province = this.areaData.province
			// 	this.selectData.city = this.areaData.city
			// }
			
			// console.log(this.provinceList.filter(data => data.label == "湖北省")[0].children); // 默认湖北省，获取市级列表
			if(this.areaData && this.areaData.province){
				this.selectData.province = this.areaData.province
				this.selectData.city = this.areaData.city
				// this.cityList = this.provinceList.filter(data => data.label == "湖北省")[0].children
			}else{
				this.selectData.province = ''
				this.selectData.city = ''
				// this.cityList = this.provinceList.filter(data => data.label == "湖北省")[0].children
			}
			
			// 新登记页面，是否是第二步预览信息，input为disabled
			// console.log(this.disabled);

			// 如果是添加著作权人，北京 天津 重庆 上海 四个直辖市  二级栏不展示区
			// console.log(this.selectData);
			if (this.isAddObligee && (this.selectData.province == '北京市' || this.selectData.province == '天津市' || this.selectData.province == '重庆市' || this.selectData.province == '上海市')){
				this.cityList = [{label: this.selectData.province}]
			}
			
		},
		methods: {
			// 省份 市 县联动
			selectProvinceFun(event) {
				// console.log(event);
				if (event) {
					if (this.isAddObligee && (event.label == '北京市' || event.label == '天津市' || event.label == '重庆市' || event.label == '上海市')){
						// 如果是添加著作权人，北京 天津 重庆 上海 四个直辖市  二级栏不展示区
						// console.log('isAddObligee');
						this.cityList = [{label: event.label,value: event.value}]
					}else{
						this.cityList = event.children
					}
				} else {
					this.cityList = []
				}
				this.areaList = [];
				this.selectData.city = {};
				this.selectData.area = {};
				this.$emit('change', {value:event.label,laber:'province',selectData:this.selectData});
			},
			selectCityFun(event) {
				if (event) {
					this.areaList = event.area
				} else {
					this.areaList = []
				}
				this.selectData.area = {};
				this.$emit('change', {value:event.label,laber:'city',selectData:this.selectData});
			},
			selectAreaFun(event) {
				// this.selectData = {
				// 	area: event.label
				// };
				this.$emit('change', {value:event.label,laber:'area',selectData:this.selectData});
			}
		}
	}
</script>
<style lang="scss" scoped>
	.linkage {
		display: flex;
		justify-content: space-between;align-items: center;
		div{
			width: calc(110% / 2.4);
			height: 40px;
		}
		/deep/.el-input__inner{
			height: 40px;
			line-height: 40px;
		}
	}
	
</style>
